import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, withRouter } from 'react-router-dom';
import Loadable from 'react-loadable';

import AdminEmptyLayout from './hoc/AdminLayouts/EmptyLayout';
import Loader from 'components/UI/Spinner/Spinner';
import ReactGA from 'react-ga';
import { ID } from 'constants/googleAnalytics';

import jwtDecode from 'jwt-decode';
import { setCurrentTeacher } from './store/actions/authActions';
import store from './store';

// favicon for platform set dynamically
import Favicon from './assets/images/favicons/favicon.ico';
import AppleFavicon from './assets/images/favicons/apple-touch-icon.png';
import Favicon32 from './assets/images/favicons/favicon-32x32.png';

import sendAnalytics from 'utils/analytics';
import { ServerLink } from 'utils';
import { showServerNotification } from 'store/actions/uiActions';

import moment from 'moment';

// Update the axios baseURL with .env variables (if prod vs if dev etc..)
import axios from 'axios';
axios.defaults.baseURL = ServerLink;
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Application-Origin'] = 'lsgo_login_application';

try {
    ReactGA.initialize(ID);
} catch (e) {
    console.error(e);
}

const Register = Loadable({
    loader: () => import('containers/Auth/Register'),
    loading: () => <Loader />,
});

const ForgotPassword = Loadable({
    loader: () => import('containers/Auth/ForgotPassword'),
    loading: () => <Loader />,
});

const ResetPassword = Loadable({
    loader: () => import('containers/Auth/ResetPassword'),
    loading: () => <Loader />,
});

const Login = Loadable({
    loader: () => import('containers/Auth/Login'),
    loading: () => <Loader />,
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hubspot: false,
            hubspotScript: false,
            chatBeta: null,
            logoutWarningTimer: null,
        };
        this.loadHubSpot = this.loadHubSpot.bind(this);
    }

    static propTypes = {
        location: PropTypes.object.isRequired,
    };

    loadHubSpot() {
        if (this.state.hubspot === false && window.location.hostname.includes('lifeskillsgo')) {
            const script = document.createElement('script');

            script.src = '//js.hs-scripts.com/4596264.js';
            script.async = true;
            script.id = 'hs-script-loader';

            document.body.appendChild(script);

            this.setState({ hubspot: true });
        }
    }

    async componentDidMount() {
        document.getElementById('favicon').href = Favicon;
        document.getElementById('favicon32').href = Favicon32;
        document.getElementById('faviconApple').href = AppleFavicon;
        const path = this.props.location.pathname;

        await axios.get('/api/v3/auth/user').then((res) => {
            if (res.data && res.data.redirect) {
                showServerNotification('Checking for existing login data', [], 2000);
                window.location.href = res.data.redirect;
            }
        });
        if (!path.includes('teacher/register') && !path.includes('teacher/verify')) {
            this.loadHubSpot();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            location: { pathname },
        } = this.props;
        const previousLocation = prevProps.location.pathname;

        if (pathname !== previousLocation) {
            window.Appcues && window.Appcues.page();
        }
        const path = this.props.location.pathname;
        if (this.state.hubspot === false && !path.includes('teacher/register') && !path.includes('teacher/verify')) {
            this.loadHubSpot();
        }
    }

    render() {
        return (
            <>
                <Switch>
                    <AdminEmptyLayout exact path='/' component={Login} />
                    <AdminEmptyLayout exact path='/teacher/register/:token' component={Register} />

                    <AdminEmptyLayout exact path='/users/forgotPassword' component={ForgotPassword} />
                    <AdminEmptyLayout exact path='/users/password/reset/:token' component={ResetPassword} />
                </Switch>

                {/* {localStorage.jwtToken && <Chat {...this.state.chatBeta} />} */}
            </>
        );
    }
}

export default withRouter(App);
